<template>
  <select 
    :id="id" 
    v-model="color_code" 
    name="colorpicker">
    <option value=""/>
    <option value="#7bd148">Green</option>
    <option value="#5484ed">Bold blue</option>
    <option value="#a4bdfc">Blue</option>
    <option value="#46d6db">Turquoise</option>
    <option value="#7ae7bf">Light green</option>
    <option value="#51b749">Bold green</option>
    <option value="#fbd75b">Yellow</option>
    <option value="#ffb878">Orange</option>
    <option value="#ff887c">Red</option>
    <option value="#dc2127">Bold red</option>
    <option value="#dbadff">Purple</option>
    <option value="#e1e1e1">Gray</option>
  </select>
</template>

<script>
export default {
    // eslint-disable-next-line vue/require-prop-types
    props: ['color', 'id'],

    data() {
        return {
            color_code: null,
        };
    },

    watch: {
        color() {
            this.color_code = this.color;
            if (this.color_code != null)
                $('#' + this.id).simplecolorpicker(
                    'selectColor',
                    this.color_code,
                );
            else $('#' + this.id).simplecolorpicker('selectColor', '');
        },
    },

    created() {
        // using vue mounted not working. use jquery to initiate color picker right after doc loaded
        var that = this;
        $(function() {
            $('#' + that.id)
                .simplecolorpicker({ theme: 'glyphicons' })
                .on('change', function() {
                    that.color_code =
                        $('#' + that.id).val() == ''
                            ? null
                            : $('#' + that.id).val();
                });
        });
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/item/colorPicker.vue